export default [
  {
    title: 'مدیریت فعالیت ها',
    icon: 'bx bx-swim',
    children: [
      {
        title: 'فعالیت ها',
        route: { name: 'activity' },
        resource: 'ActivityManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'activitycategory' },
        resource: 'ActivityCategoryManager',
        action: 'show',
      },
      {
        title: 'عضله ها',
        route: { name: 'muscle' },
        resource: 'ActivityManager',
        action: 'show',
      },
      {
        title: 'گروه های ورزشی',
        route: { name: 'activitygroup' },
        resource: 'ActivityGroupManager',
        action: 'show',
      },
      {
        title: 'برنامه های ورزشی',
        route: { name: 'activitypackage' },
        resource: 'ActivityPackageManager',
        action: 'show',
      },
      {
        title: 'دوره های های ورزشی',
        route: { name: 'activitypackagecourse' },
        resource: 'ActivityPackageCourseManager',
        action: 'show',
      },
      {
        title: 'نظرهای فعالیت',
        route: { name: 'activitycomment' },
        resource: 'ActivityCommentManager',
        action: 'show',
      },
      {
        title: 'نظرهای برنامه ورزشی',
        route: { name: 'activitypackagecomment' },
        resource: 'ActivityPackageCommentManager',
        action: 'show',
      },
    ],
  },
]
